import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ErpApprovalsPage = lazy(() =>
	import("@/features/admin/erp-approvals-page").then((m) => ({ default: m.ErpApprovalsPage })),
);

// Filtr statusu historii w URL — F5 wraca do tego samego widoku.
const searchSchema = z.object({
	status: z.enum(["pending", "approved", "rejected", "expired"]).optional().catch(undefined),
});

// Zatwierdzenia SQL konsoli ERP (F4) bez wybierania apteki. Element bez grantów =
// tylko super_admin, ta sama publiczność co tryb apteki konsoli (backend: is_console_admin).
export const Route = createFileRoute("/_auth/synchronizacja/zatwierdzenia-sql")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.synchronizacja-apteki.zatwierdzenia-sql",
			location.pathname,
		);
	},
	component: ErpApprovalsPage,
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
});
